import { Skeleton, SkeletonText } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

/* The docked sidebar's menu before its rows are known — ONE drawing, used by
   the cold-launch shell (route-skeleton's SidebarBones) and by the real
   sidebar while its permission reads are out (ModeAwareSidebar).

   The real sidebar used to draw nothing until those three reads answered, so
   a cold launch went skeleton rows → an empty menu for ~400ms → real rows: the
   nav blinked out and back. Drawing the same bones in both places means the
   hand-over from the shell skeleton to the real sidebar changes nothing on
   screen, and the rows arrive into the place they were already shown in
   (Andrew, 2026-10-27: nav never shifts). */

const NAV_ROW = "flex w-full min-h-[40px] coarse:min-h-[44px] items-center gap-3 rounded px-3 text-body";
export const SIDEBAR_SECTION_LABEL = "px-3 pb-1.5 text-micro font-bold uppercase tracking-[.09em] text-sidebar-dim";

/** A sidebar row before its item: the icon's 18px square and a label line. */
export function NavRowBone({ width }: { width: string }) {
  return (
    <div className={NAV_ROW}>
      <Skeleton className="size-[18px] shrink-0 rounded-xs bg-[hsl(var(--menu-wash)/0.1)]" />
      <span className="flex-1 text-sidebar-foreground/80"><SkeletonText className={cn(width, "[&>span]:bg-[hsl(var(--menu-wash)/0.1)]")} /></span>
    </div>
  );
}

/** A project's menu rows and the Switch Project block that closes them. */
export function ProjectRowBones() {
  return (
    <div className="flex flex-col gap-0.5 coarse:gap-1">
      {["w-24", "w-20", "w-14", "w-32", "w-16", "w-24", "w-28", "w-24", "w-20", "w-36", "w-32"].map((w, i) => (
        <NavRowBone key={i} width={w} />
      ))}
      <div className="mb-3 mt-4 flex min-h-[52px] w-full items-center gap-2.5 rounded bg-[hsl(var(--menu-wash)/0.06)] py-1.5 pl-1.5 pr-3">
        <Skeleton className="size-9 shrink-0 rounded-full bg-[hsl(var(--menu-wash)/0.1)]" />
        <span className="flex-1 text-body font-semibold"><SkeletonText className="w-2/3 [&>span]:bg-[hsl(var(--menu-wash)/0.1)]" /></span>
      </div>
    </div>
  );
}
